import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";
import * as layers from "@styles/emotion-styles/layers";

export const container = css`
  width: 100%;
`;

export const searchWrapper = css`
  display: flex;
  flex: 1 1 100%;
  justify-content: space-between;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const searchWrapperSticky = (theme: Theme) => css`
  background-color: ${theme.surface.level0};
  padding: 1rem 0;
  position: sticky;
  top: 4rem;
  z-index: ${layers.indexDrawerMax};

  @media (min-width: ${dimensions.tablet}) {
    margin-bottom: 0;
    margin-top: 0;
    top: 5rem;
    padding-top: 1rem;
  }
`;

export const marginless = css`
  margin: 0;
`;
